import { jsx } from 'react/jsx-runtime';
import { EditorStack } from './EditorStack.js';

const EditorRows = ({ children }) => {
  return /* @__PURE__ */ jsx(EditorStack, { gap: 0.5, direction: "column", children });
};

export { EditorRows };
//# sourceMappingURL=EditorRows.js.map
